import React, { ReactElement } from 'react';
import { space } from '@op/opds.tokens';
import { Message, useMessage } from '@messageformat/react';
import CourseTaskHeader from '../CourseTaskHeader';
import DiversityAnalyzer from './DiversityAnalyzer/DiversityAnalyzer';
import { optionsFunds } from './DiversityAnalyzer/options';
import parseMsgContent from '../../util/parseMsgContent';
import CourseContent from '../CourseContent';

const TaskThree = (): ReactElement => {
  const taskThreeBody = useMessage('course7.task3.body');
  const parsedTaskThreeBody = parseMsgContent(taskThreeBody);
  return (
    <div style={{ marginBottom: space.xl }}>
      <CourseTaskHeader questionNumber={3} totalQuestions={3} />
      <h3
        className="opds-styles-v1-text-hero-small"
        style={{ textAlign: 'center', marginTop: space.xxl, marginBottom: space.default }}
      >
        <Message id="course7.task3.title" />
      </h3>
      <CourseContent content={parsedTaskThreeBody} />
      <DiversityAnalyzer options={optionsFunds} type="FUND" />
    </div>
  );
};

export default TaskThree;
